import { defineMessages } from 'react-intl';

export const messages: {
	otherOption: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	otherOptionTextLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	otherOption: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.radio-input.view.other-option',
		description: 'The label for the Other option in the radio choice field',
		defaultMessage: 'Other...',
	},
	otherOptionTextLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.radio-input.view.other-option-text-label',
		description: 'Label for the radio choice field other text box in view mode, for accessibility',
		defaultMessage: '{label} radio choice field other option text area view',
	},
});
